// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Transformer Tariffs */
div.transformer-tariffs .vat-header {
  font: 500 14px/15px Roboto;
  letter-spacing: 0.28px;
  color: #424242;
}

div.transformer-tariffs .vat-value {
  background-color: #F5F5F5;
}

div.transformer-tariffs .vat-value.error {
  background-color: red;
  font: 700 14px/15px Roboto;
}

div.transformer-tariffs .vat-value > span {
  text-align: left;
  font: 400 15px/15px Roboto;
  letter-spacing: 0.3px;
}

div.transformer-tariffs div.tariff-row:nth-child(even) {
  background-color: #F4F4F4;
}

div.transformer-tariffs div.data-columns > div,
div.transformer-tariffs div.capacity-column {
  border-left: solid 1px #A0A0A0;
}

div.transformer-tariffs div.tariff-row span.currency {
  text-align: left;
  font: 700 13px/15px Roboto;
  letter-spacing: 0.26px;
  color: #424242;
  padding-left: 10px;
  margin-right: -10px;
}

div.transformer-tariffs div.tariff-row input {
  width: 100%;
  flex: 1;
  text-align: left;
  font: 700 13px/15px Roboto;
  letter-spacing: 0.26px;
  color: #424242;
  border: none;
  background-color: transparent;
  padding: 0px;
  margin-left: 10px;
  cursor: text !important;
}

div.transformer-tariffs div.tariff-row input:focus {
  outline: none;
  border-bottom: 1px solid;
  margin-bottom: -1px;
}

div.transformer-tariffs div.tariff-row input::-webkit-outer-spin-button,
div.transformer-tariffs div.tariff-row input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
div.transformer-tariffs div.tariff-row input[type=number] {
  -moz-appearance: textfield;
}

div.transformer-tariffs div.tariff-row span.vat {
  text-align: left;
  font: 400 13px/15px Roboto;
  letter-spacing: 0.26px;
  color: #424242;
  padding-right: 10px;
}

.transformer-tariffs div.submitting {
  position: relative;
}

/* LPU */
div.transformer-tariffs.lpu .transmission-zone {
  background-color: #8FA1B7;
  color: white;
  text-align: center;
  font: 700 15px/15px Roboto;
  letter-spacing: 0.3px;
}

div.transformer-tariffs.lpu .voltage {
  background-color: #7FB1B2;
  color: white;
  text-align: center;
  font: 700 15px/37px Roboto;
  letter-spacing: 0.3px;
}

div.transformer-tariffs.lpu .network-capacity {
  background-color: #76A25B;
  text-align: center;
  font: 700 15px/15px Roboto;
  letter-spacing: 0.3px;
}

div.transformer-tariffs.lpu .network-capacity > div.vat {
  font: 400 13px/37px Roboto;
  letter-spacing: 0.26px;
  padding-right: 10px;
}

div.transformer-tariffs.lpu .legacy-charge {
  background-color: #8fa1b7;
  text-align: center;
  font: 700 15px/15px Roboto;
  letter-spacing: 0.3px;
}

div.transformer-tariffs.lpu .legacy-charge > div.vat {
  font: 400 13px/37px Roboto;
  letter-spacing: 0.26px;
  padding-right: 10px;
}

div.transformer-tariffs.lpu .generation-capacity-charge {
  background-color: #e8e8e8;
  text-align: center;
  font: 700 15px/15px Roboto;
  letter-spacing: 0.3px;
}

div.transformer-tariffs.lpu .generation-capacity-charge > div.vat {
  font: 400 13px/37px Roboto;
  letter-spacing: 0.26px;
  padding-right: 10px;
}

div.transformer-tariffs.lpu .average {
  background-color: #C8C7CD;
  text-align: center;
  font: 700 15px/37px Roboto;
  letter-spacing: 0.3px;
  color: #494949;
}

div.transformer-tariffs.lpu .high-header {
  background-color: #92C46D;
  font: 400 14px/37px Roboto;
  border-bottom: 1px solid #424242;
}

div.transformer-tariffs.lpu .low-header {
  background-color: #C6E170;
  font: 400 14px/37px Roboto;
  border-bottom: 1px solid #424242;
}

div.transformer-tariffs.lpu .high-header span,
div.transformer-tariffs.lpu .low-header span {
  font-weight: bold;
}

div.transformer-tariffs.lpu .high span,
div.transformer-tariffs.lpu .low span {
  font-weight: bold;
}

div.transformer-tariffs.lpu .high div.vat,
div.transformer-tariffs.lpu .low div.vat {
  font: 400 13px/37px Roboto;
  letter-spacing: 0.26px;
  padding-right: 10px;
}

div.transformer-tariffs.lpu .high.peak {
  background-color: #92C46D;
  border-right: 1px solid #A0A0A0;
}

div.transformer-tariffs.lpu .high.standard {
  background-color: #A7D189;
  border-right: 1px solid #A0A0A0;
}

div.transformer-tariffs.lpu .high.off-peak {
  background-color: #BEDCA8;
}

div.transformer-tariffs.lpu .low.peak {
  background-color: #C6E170;
  border-right: 1px solid #A0A0A0;
}

div.transformer-tariffs.lpu .low.standard {
  background-color: #D2E68D;
  border-right: 1px solid #A0A0A0;
}

div.transformer-tariffs.lpu .low.off-peak {
  background-color: #DDECA9;
}

div.transformer-tariffs.lpu .zone-cell > span,
div.transformer-tariffs.lpu .voltage-cell > span {
  font: 400 13px/15px Roboto;
  letter-spacing: 0.26px;
  color: #424242;
}

div.transformer-tariffs.lpu .voltage-cell {
  border-left: solid 1px #A0A0A0;
}

div.transformer-tariffs.lpu .categories {
  background-color: #339FA2;
  font: bold 15px/15px Roboto;
  letter-spacing: 0.3px;
  color: #FFFFFF;
  min-height: 50px !important;
}

div.transformer-tariffs.lpu .service-charge {
  background-color: #64B2B4;
  font: bold 15px/15px Roboto;
  letter-spacing: 0.3px;
  color: #FFFFFF;
}

div.transformer-tariffs.lpu .admin-charge {
  background-color: #93C1C3;
  font: bold 15px/15px Roboto;
  letter-spacing: 0.3px;
  color: #FFFFFF;
}

div.transformer-tariffs.lpu .service-charge > .vat,
div.transformer-tariffs.lpu .admin-charge > .vat {
  font: 400 13px/24px Roboto;
  letter-spacing: 0.26px;
  color: #FFFFFF;
  padding-right: 10px;
}

div.transformer-tariffs.lpu .reactive-energy-charge {
  background-color: #339FA2;
  font: bold 15px/15px Roboto;
  letter-spacing: 0.3px;
  color: #FFFFFF;
  min-height: 44px !important;
}

div.transformer-tariffs.lpu .reactive-energy-high-season {
  background-color: #64B2B4;
  font: Bold 15px/20px Roboto;
  letter-spacing: 0.3px;
  color: #FFFFFF;
  min-height: 33px !important;
}

div.transformer-tariffs.lpu .reactive-energy-low-season {
  background-color: #93C1C3;
  font: Bold 15px/20px Roboto;
  letter-spacing: 0.3px;
  color: #FFFFFF;
  min-height: 33px !important;
}

div.transformer-tariffs.lpu .reactive-energy-high-season > .vat,
div.transformer-tariffs.lpu .reactive-energy-low-season > .vat {
  font: 400 13px/24px Roboto;
  letter-spacing: 0.26px;
  color: #FFFFFF;
  padding-right: 10px;
}

/* SPU Specific */
.transformer-tariffs.spu .energy-charge {
  background-color: #485D70;
  font: bold 16px/20px Roboto;
  letter-spacing: 0.32px;
  color: #FFFFFF;
}

.transformer-tariffs.spu .ancillary-service {
  background-color: #539798;
  font: bold 16px/20px Roboto;
  letter-spacing: 0.32px;
  color: #FFFFFF;
}

.transformer-tariffs.spu .network-demand {
  background-color: #A7D189;
  font: bold 16px/20px Roboto;
  letter-spacing: 0.32px;
  color: #424242;
}

.transformer-tariffs.spu .generation-capacity-charge {
  background-color: rgba(229, 229, 229, 0.5137254902);
  font: bold 16px/20px Roboto;
  letter-spacing: 0.32px;
  color: #424242;
}

.transformer-tariffs.spu .network-capacity {
  background-color: #D2E68D;
  font: bold 16px/20px Roboto;
  letter-spacing: 0.32px;
  color: #424242;
}

.transformer-tariffs.spu .service-charge {
  background-color: #E5E5E5;
  font: bold 16px/20px Roboto;
  letter-spacing: 0.32px;
  color: #424242;
}

div.transformer-tariffs.spu div.tariff-row .landrate {
  background-color: #C6E170;
  font: bold 16px/37px Roboto;
  letter-spacing: 0.32px;
  color: #424242;
}

div.transformer-tariffs.spu div.tariff-row:nth-child(even) .landrate {
  background-color: #DDECA9;
}

div.transformer-tariffs.spu .empty {
  background-color: #A6A6A6;
}

div.transformer-tariffs.spu .disclaimer {
  font: 400 16px/37px Roboto;
  letter-spacing: 0.32px;
  color: #424242;
}

div.transformer-tariffs.spu .br {
  border-right: solid 1px #A6A6A6;
}`, "",{"version":3,"sources":["webpack://./src/style/transformerTariffs.scss"],"names":[],"mappings":"AAEA,wBAAA;AACA;EACI,0BAAA;EACA,sBAAA;EACA,cAAA;AADJ;;AAGA;EACI,yBAAA;AAAJ;;AAEA;EACI,qBAAA;EACA,0BAAA;AACJ;;AACA;EACI,gBAAA;EACA,0BAAA;EACA,qBAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ;;AACA;;EAEI,8BAAA;AAEJ;;AACA;EACI,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAEJ;;AACA;EACI,WAAA;EACA,OAAA;EACA,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,cAAA;EAEA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,iBAAA;EAEA,uBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,wBAAA;EACA,mBAAA;AAAJ;;AAGA;;EAEE,wBAAA;EACA,SAAA;AAAF;;AAGA,YAAA;AACA;EACE,0BAAA;AAAF;;AAGA;EACI,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AAAJ;;AAIA;EACI,kBAAA;AADJ;;AAIA,QAAA;AACA;EACI,yBAAA;EACA,YAxFU;EAyFV,kBAAA;EACA,0BAAA;EACA,qBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,YAhGU;EAiGV,kBAAA;EACA,0BAAA;EACA,qBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;AADJ;;AAGA;EACI,0BAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;AAAJ;;AAEA;EACI,0BAAA;EACA,sBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;AACJ;;AACA;EACI,0BAAA;EACA,sBAAA;EACA,mBAAA;AAEJ;;AACA;EACI,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;EACA,cAAA;AAEJ;;AACA;EACI,yBAAA;EACA,0BAAA;EACA,gCAAA;AAEJ;;AAAA;EACI,yBAAA;EACA,0BAAA;EACA,gCAAA;AAGJ;;AADA;;EAEI,iBAAA;AAIJ;;AADA;;EAEI,iBAAA;AAIJ;;AADA;;EAEI,0BAAA;EACA,sBAAA;EACA,mBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,+BAAA;AAIJ;;AADA;EACI,yBAAA;EACA,+BAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,+BAAA;AAIJ;;AADA;EACI,yBAAA;EACA,+BAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;;EAEI,0BAAA;EACA,sBAAA;EACA,cAAA;AAIJ;;AADA;EACI,8BAAA;AAIJ;;AADA;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;EAEA,2BAAA;AAGJ;;AAAA;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;AAGJ;;AAAA;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;AAGJ;;AAAA;;EAEI,0BAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;EAEA,2BAAA;AAEJ;;AACA;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;EAEA,2BAAA;AACJ;;AAEA;EACI,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;EAEA,2BAAA;AAAJ;;AAGA;;EAEI,0BAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AAAJ;;AAGA,iBAAA;AACA;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;AAAJ;;AAEA;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;AACJ;;AACA;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;AAEJ;;AAAA;EACI,mDAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;AAGJ;;AADA;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;AAIJ;;AAFA;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;AAKJ;;AAFA;EACI,yBAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;AAKJ;;AAFA;EACI,yBAAA;AAKJ;;AAFA;EACI,yBAAA;AAKJ;;AAFA;EACI,0BAAA;EACA,sBAAA;EACA,cAAA;AAKJ;;AAFA;EACI,+BAAA;AAKJ","sourcesContent":["$COLOR_WHITE: get('colors.white');\n\n/* Transformer Tariffs */\ndiv.transformer-tariffs .vat-header {\n    font: 500 14px/15px Roboto;\n    letter-spacing: 0.28px;\n    color: #424242;\n}\ndiv.transformer-tariffs .vat-value {\n    background-color: #F5F5F5;\n}\ndiv.transformer-tariffs .vat-value.error {\n    background-color: red;\n    font: 700 14px/15px Roboto;\n}\ndiv.transformer-tariffs .vat-value > span {\n    text-align: left;\n    font: 400 15px/15px Roboto;\n    letter-spacing: 0.3px;\n}\n\ndiv.transformer-tariffs div.tariff-row:nth-child(even) {\n    background-color: #F4F4F4;\n}\n\ndiv.transformer-tariffs div.data-columns > div,\ndiv.transformer-tariffs div.capacity-column {\n    border-left: solid 1px #A0A0A0;\n}\n\ndiv.transformer-tariffs div.tariff-row span.currency {\n    text-align: left;\n    font: 700 13px/15px Roboto;\n    letter-spacing: 0.26px;\n    color: #424242;\n    padding-left: 10px;\n    margin-right: -10px;\n}\n\ndiv.transformer-tariffs div.tariff-row input {\n    width: 100%;\n    flex: 1;\n    text-align: left;\n    font: 700 13px/15px Roboto;\n    letter-spacing: 0.26px;\n    color: #424242;\n\n    border: none;\n    background-color: transparent;\n    padding: 0px;\n    margin-left: 10px;\n\n    cursor: text !important;\n}\n\ndiv.transformer-tariffs div.tariff-row input:focus {\n    outline: none;    \n    border-bottom: 1px solid;\n    margin-bottom: -1px;\n}\n\ndiv.transformer-tariffs div.tariff-row input::-webkit-outer-spin-button,\ndiv.transformer-tariffs div.tariff-row input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ndiv.transformer-tariffs div.tariff-row input[type=number] {\n  -moz-appearance: textfield;\n}\n\ndiv.transformer-tariffs div.tariff-row span.vat {\n    text-align: left;\n    font: 400 13px/15px Roboto;\n    letter-spacing: 0.26px;\n    color: #424242;\n    padding-right: 10px;\n}\n\n\n.transformer-tariffs div.submitting {\n    position: relative;\n}\n\n/* LPU */\ndiv.transformer-tariffs.lpu .transmission-zone {\n    background-color: #8FA1B7;\n    color: $COLOR_WHITE;\n    text-align: center;\n    font: 700 15px/15px Roboto;\n    letter-spacing: 0.3px;\n}\n\ndiv.transformer-tariffs.lpu .voltage {\n    background-color: #7FB1B2;\n    color: $COLOR_WHITE;\n    text-align: center;\n    font: 700 15px/37px Roboto;\n    letter-spacing: 0.3px;\n}\n\ndiv.transformer-tariffs.lpu .network-capacity {\n    background-color: #76A25B;\n    text-align: center;\n    font: 700 15px/15px Roboto;\n    letter-spacing: 0.3px;\n}\ndiv.transformer-tariffs.lpu .network-capacity > div.vat {\n    font: 400 13px/37px Roboto;\n    letter-spacing: 0.26px;\n    padding-right: 10px;\n}\n\ndiv.transformer-tariffs.lpu .legacy-charge {\n    background-color: #8fa1b7;\n    text-align: center;\n    font: 700 15px/15px Roboto;\n    letter-spacing: 0.3px;\n}\ndiv.transformer-tariffs.lpu .legacy-charge > div.vat {\n    font: 400 13px/37px Roboto;\n    letter-spacing: 0.26px;\n    padding-right: 10px;\n}\n\ndiv.transformer-tariffs.lpu .generation-capacity-charge {\n    background-color: #e8e8e8;\n    text-align: center;\n    font: 700 15px/15px Roboto;\n    letter-spacing: 0.3px;\n}\ndiv.transformer-tariffs.lpu .generation-capacity-charge > div.vat {\n    font: 400 13px/37px Roboto;\n    letter-spacing: 0.26px;\n    padding-right: 10px;\n}\n\ndiv.transformer-tariffs.lpu .average {\n    background-color: #C8C7CD;\n    text-align: center;\n    font: 700 15px/37px Roboto;\n    letter-spacing: 0.3px;\n    color: #494949;\n}\n\ndiv.transformer-tariffs.lpu .high-header {\n    background-color: #92C46D;\n    font: 400 14px/37px Roboto;\n    border-bottom: 1px solid #424242;\n}\ndiv.transformer-tariffs.lpu .low-header {\n    background-color: #C6E170;\n    font: 400 14px/37px Roboto;\n    border-bottom: 1px solid #424242;\n}\ndiv.transformer-tariffs.lpu .high-header span,\ndiv.transformer-tariffs.lpu .low-header span {\n    font-weight: bold;\n}\n\ndiv.transformer-tariffs.lpu .high span,\ndiv.transformer-tariffs.lpu .low span {\n    font-weight: bold;\n}\n\ndiv.transformer-tariffs.lpu .high div.vat,\ndiv.transformer-tariffs.lpu .low div.vat {\n    font: 400 13px/37px Roboto;\n    letter-spacing: 0.26px;\n    padding-right: 10px;\n}\n\ndiv.transformer-tariffs.lpu .high.peak {\n    background-color: #92C46D;\n    border-right: 1px solid #A0A0A0;\n}\n\ndiv.transformer-tariffs.lpu .high.standard {\n    background-color: #A7D189;\n    border-right: 1px solid #A0A0A0;\n}\n\ndiv.transformer-tariffs.lpu .high.off-peak {\n    background-color: #BEDCA8;\n}\n\ndiv.transformer-tariffs.lpu .low.peak {\n    background-color: #C6E170;\n    border-right: 1px solid #A0A0A0;\n}\n\ndiv.transformer-tariffs.lpu .low.standard {\n    background-color: #D2E68D;\n    border-right: 1px solid #A0A0A0;\n}\n\ndiv.transformer-tariffs.lpu .low.off-peak {\n    background-color: #DDECA9;\n}\n\ndiv.transformer-tariffs.lpu .zone-cell > span,\ndiv.transformer-tariffs.lpu .voltage-cell > span {\n    font: 400 13px/15px Roboto;\n    letter-spacing: 0.26px;\n    color: #424242;\n}\n\ndiv.transformer-tariffs.lpu .voltage-cell {\n    border-left: solid 1px #A0A0A0;\n}\n\ndiv.transformer-tariffs.lpu .categories {\n    background-color: #339FA2;\n    font: bold 15px/15px Roboto;\n    letter-spacing: 0.3px;\n    color: #FFFFFF;\n\n    min-height: 50px !important;\n}\n\ndiv.transformer-tariffs.lpu .service-charge {\n    background-color: #64B2B4;\n    font: bold 15px/15px Roboto;\n    letter-spacing: 0.3px;\n    color: #FFFFFF;\n}\n\ndiv.transformer-tariffs.lpu .admin-charge {\n    background-color: #93C1C3;\n    font: bold 15px/15px Roboto;\n    letter-spacing: 0.3px;\n    color: #FFFFFF;\n}\n\ndiv.transformer-tariffs.lpu .service-charge > .vat,\ndiv.transformer-tariffs.lpu .admin-charge > .vat {\n    font: 400 13px/24px Roboto;\n    letter-spacing: 0.26px;\n    color: #FFFFFF;\n    padding-right: 10px;\n}\n\ndiv.transformer-tariffs.lpu .reactive-energy-charge {\n    background-color: #339FA2;\n    font: bold 15px/15px Roboto;\n    letter-spacing: 0.3px;\n    color: #FFFFFF;\n\n    min-height: 44px !important;\n}\n\ndiv.transformer-tariffs.lpu .reactive-energy-high-season {\n    background-color: #64B2B4;\n    font: Bold 15px/20px Roboto;\n    letter-spacing: 0.3px;\n    color: #FFFFFF;\n\n    min-height: 33px !important;\n}\n\ndiv.transformer-tariffs.lpu .reactive-energy-low-season {\n    background-color: #93C1C3;\n    font: Bold 15px/20px Roboto;\n    letter-spacing: 0.3px;\n    color: #FFFFFF;\n\n    min-height: 33px !important;\n}\n\ndiv.transformer-tariffs.lpu .reactive-energy-high-season > .vat,\ndiv.transformer-tariffs.lpu .reactive-energy-low-season > .vat {\n    font: 400 13px/24px Roboto;\n    letter-spacing: 0.26px;\n    color: #FFFFFF;\n    padding-right: 10px;\n}\n\n/* SPU Specific */\n.transformer-tariffs.spu .energy-charge {\n    background-color: #485D70;\n    font: bold 16px/20px Roboto;\n    letter-spacing: 0.32px;\n    color: #FFFFFF;\n}\n.transformer-tariffs.spu .ancillary-service {\n    background-color: #539798;\n    font: bold 16px/20px Roboto;\n    letter-spacing: 0.32px;\n    color: #FFFFFF;\n}\n.transformer-tariffs.spu .network-demand {\n    background-color: #A7D189;\n    font: bold 16px/20px Roboto;\n    letter-spacing: 0.32px;\n    color: #424242;\n}\n.transformer-tariffs.spu .generation-capacity-charge {\n    background-color: #e5e5e583;\n    font: bold 16px/20px Roboto;\n    letter-spacing: 0.32px;\n    color: #424242;\n}\n.transformer-tariffs.spu .network-capacity {\n    background-color: #D2E68D;\n    font: bold 16px/20px Roboto;\n    letter-spacing: 0.32px;\n    color: #424242;\n}\n.transformer-tariffs.spu .service-charge {\n    background-color: #E5E5E5;\n    font: bold 16px/20px Roboto;\n    letter-spacing: 0.32px;\n    color: #424242;\n}\n\ndiv.transformer-tariffs.spu div.tariff-row .landrate {\n    background-color: #C6E170;\n    font: bold 16px/37px Roboto;\n    letter-spacing: 0.32px;\n    color: #424242;\n}\n\ndiv.transformer-tariffs.spu div.tariff-row:nth-child(even) .landrate {\n    background-color: #DDECA9;\n}\n\ndiv.transformer-tariffs.spu .empty {\n    background-color: #A6A6A6;\n}\n\ndiv.transformer-tariffs.spu .disclaimer {\n    font: 400 16px/37px Roboto;\n    letter-spacing: 0.32px;\n    color: #424242;\n}\n\ndiv.transformer-tariffs.spu .br {\n    border-right: solid 1px #A6A6A6;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
